/* eslint-disable react/prop-types */
import React, { ComponentType } from 'react'
import { AppLoading } from 'live/components/ui/Loading'

export const SuspenseWrapper: React.FC = ({ children }) => {
    return <React.Suspense fallback={<AppLoading show={true} />}>{children}</React.Suspense>
}

export function withSuspenseWrapper<P>(Component: ComponentType<P>): ComponentType<P> {
    const WrappedBySuspense: React.FC<P> = props => (
        <SuspenseWrapper>
            <Component {...props} />
        </SuspenseWrapper>
    )

    return WrappedBySuspense
}
